import React from 'react';
import { Text } from '@fluentui/react-components';
import type { SelectedEntity } from '../../api/types';
import { EntitySyncOptionsDialog } from './EntitySyncOptionsDialog';
import { IncrementalOverlapField } from './IncrementalOverlapField';
import { NormalizedRetentionField, type NormalizedRetentionPolicy } from './NormalizedRetentionField';

interface IncrementalRetentionOptionsProps {
  selection: SelectedEntity;
  policy: NormalizedRetentionPolicy;
  disabled?: boolean;
  onChange: (selection: SelectedEntity) => void;
}

export const IncrementalRetentionOptions: React.FC<IncrementalRetentionOptionsProps> = ({
  selection, policy, disabled, onChange,
}) => (
  <EntitySyncOptionsDialog selection={selection} title={`Configure sync · ${selection.label}`}
    disabled={disabled} onDone={draft => onChange({ ...draft, sync_mode: 'incremental',
      incremental_behavior: 'append_only', retention_days: draft.retention_days ?? policy.default_days,
      overlap_seconds: draft.overlap_seconds ?? 30 })}
    summary={`Incremental append-only · ${selection.overlap_seconds ?? 30}s look-back · ${selection.retention_days ?? policy.default_days} days retention`}>
    {(draft, setDraft) => (
      <div className="polling-options">
        <Text size={200}>Application Insights tables use incremental append-only ingestion after their initial snapshot.</Text>
        <IncrementalOverlapField value={draft.overlap_seconds} disabled={disabled}
          onChange={seconds => setDraft({ ...draft, overlap_seconds: seconds })} />
        <NormalizedRetentionField value={draft.retention_days} policy={policy} disabled={disabled}
          onChange={days => setDraft({ ...draft, retention_days: days })} />
      </div>
    )}
  </EntitySyncOptionsDialog>
);